import React from 'react';

export default () => {
  return (
    <div className='dtb-db-iframe-wrap'>
      <iframe
        title="Supply Chain Sample"
        width="100%"
        height="100%"
        src='https://app.powerbi.com/reportEmbed?reportId=4bfed39e-3ae3-471f-8c63-e1efed98d578&autoAuth=true&ctid=8bb47ce5-5436-450f-ab60-f8471daa1980'
        frameBorder='0'
        allowFullScreen='true'></iframe>
    </div>
  );
}
